module.exports = __webpack_public_path__ + "static/media/safari.0b8f611d.png";